import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().max(64, 'Max length of name is 64 characters!').required(),
  description: Yup.string().max(1000, 'Max length of description is 1000 characters!').nullable(),
});